import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useCurrency } from "@/context/CurrencyContext";
import { Link } from "react-router-dom";

export default function AccountPage() {
  const { user } = useAuth();
  const { format } = useCurrency();
  const [bookings, setBookings] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  useEffect(() => {
    api.get("/bookings/mine").then(r => setBookings(r.data.bookings));
    if (user?.wishlist?.length) {
      Promise.all(user.wishlist.map(s => api.get(`/packages/${s}`).then(r => r.data.package))).then(setWishlist);
    }
  }, [user]);
  if (!user) return null;
  return (
    <div className="pt-32 pb-24 bg-slate-50 dark:bg-slate-950 min-h-screen">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] font-semibold">My Account</div>
          <h1 className="mt-3 text-4xl font-bold text-blue-950 dark:text-white">Hi {user.name} ✦</h1>
          <p className="mt-2 text-slate-500">{user.email}</p>
        </div>
        <section className="mb-16">
          <h2 className="text-2xl font-bold text-blue-950 dark:text-white mb-4">Booking history</h2>
          <div className="rounded-3xl bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-white/10 overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-slate-100 dark:bg-white/5 text-left">
                <tr><th className="p-4">Package</th><th className="p-4">Travel date</th><th className="p-4">Passengers</th><th className="p-4">Amount</th><th className="p-4">Status</th></tr>
              </thead>
              <tbody>
                {bookings.map(b => (
                  <tr key={b.id} data-testid={`booking-${b.id}`} className="border-t border-slate-100 dark:border-white/5">
                    <td className="p-4 font-medium text-blue-950 dark:text-white">{b.package_title}</td>
                    <td className="p-4">{b.travel_date}</td>
                    <td className="p-4">{b.passengers}</td>
                    <td className="p-4">₹{b.amount.toLocaleString('en-IN')} <span className="text-xs text-slate-500">({format(b.amount)})</span></td>
                    <td className="p-4"><span className={`px-2 py-1 rounded-full text-xs ${b.status === "confirmed" ? "bg-emerald-500/10 text-emerald-600" : "bg-amber-500/10 text-amber-600"}`}>{b.status}</span></td>
                  </tr>
                ))}
                {!bookings.length && <tr><td colSpan={5} className="p-8 text-center text-slate-500">No bookings yet. <Link to="/packages" className="text-[#D4AF37]">Start planning</Link>.</td></tr>}
              </tbody>
            </table>
          </div>
        </section>
        <section>
          <h2 className="text-2xl font-bold text-blue-950 dark:text-white mb-4">My wishlist</h2>
          {wishlist.length === 0 ? <div className="text-slate-500">No favourites yet.</div> :
          <div className="grid md:grid-cols-3 gap-6">{wishlist.map(p => (
            <Link key={p.slug} to={`/packages/${p.slug}`} className="rounded-2xl overflow-hidden card-lift bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-white/10">
              <img src={p.image} alt="" className="h-40 w-full object-cover"/>
              <div className="p-4"><div className="font-semibold text-blue-950 dark:text-white">{p.title}</div><div className="text-xs text-slate-500">{format(p.price)}</div></div>
            </Link>))}
          </div>}
        </section>
      </div>
    </div>
  );
}
